import React, { useState, useEffect, useCallback } from "react";
import { Icon } from '@iconify/react/dist/iconify.js';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DistrictWiseSummary from './ReportDistrictWiseSummary';

const ReportDistrictPage = () => {
  const [overallDistrictData, setOverallDistrictData] = useState([]);
  const [loading, setLoading] = useState(true);
  const API_BASE_URL = process.env.REACT_APP_BE_API_URL;

  // Define fetchData with useCallback before useEffect
  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");
      
      // Fetch overall district summary
      const overallResponse = await axios.post(
        `${API_BASE_URL}/api/plantation/pafs/overall-district-summary`,
        {},
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        }
      );
      
      if (overallResponse.data.status) {
        setOverallDistrictData(overallResponse.data.data);
      } else {
        showToast("Failed to fetch district data.", "error");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      showToast("Failed to fetch data. Please try again.", "error");
    } finally {
      setLoading(false);
    }
  }, [API_BASE_URL]); // Include API_BASE_URL as a dependency

  // Move showToast before useEffect as well, since it's used in fetchData
  const showToast = (message, type = "success") => {
    const toastOptions = {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    };

    switch (type) {
      case "success":
        toast.success(message, toastOptions);
        break;
      case "error":
        toast.error(message, toastOptions);
        break;
      default:
        toast(message, toastOptions);
    }
  };

  useEffect(() => {
    fetchData();
  }, [fetchData]); // Include fetchData in the dependency array

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '50vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="col-lg-12 col-md-12 col-sm-12">
      <ToastContainer />
      <div className="text-center">
        <h6 className="mb-20 text-2xl font-bold text-gray-800 flex items-center justify-center">
          <Icon icon="mdi:file-document-alert" className="text-3xl mx-3 my-1" />
          District Report
        </h6>
      </div>
      
      <div className="col-xxl-12">
        <DistrictWiseSummary overallDistrictData={overallDistrictData} />
      </div>
    </div>
  );
};

export default ReportDistrictPage;